export class AdsConfig {
    public serviceList = [{
        type: 1,
        name: 'Duct Cleaning计件产品测试一下长度的问题，没什么的',
        img: 'https://uat-bims.realjaja.com/web/image?model=product.template&id=4&field=image_medium&unique=1568056986115',
        extParams: {
            serverId: 4,
            detailUrl: 'bimsEntrust/serviceDetail?id=4'
        }
    }, {
        type: 1,
        name: '售前验房商品',
        img: 'https://uat-bims.realjaja.com/web/image?model=product.template&id=17&field=image_medium&unique=1568056986115',
        extParams: {
            serverId: 17,
            detailUrl: 'bimsEntrust/serviceDetail?id=17'
        }
    }, {
        type: 2,
        name: '荣仔-专属',
        img: 'https://uat-bims.realjaja.com/web/image?model=x_product_theme&id=35&field=x_banner',
        extParams: {
            packageId: 35,
        }
    }, {
        type: 3,
        name: '服务频道',
        img: 'https://uat-bims.realjaja.com/web/image?model=x_product_theme&id=35&field=x_banner',
        extParams: {}
    }];
}
